exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.delete[data-v-12a6c587] {\n  position: absolute;\n  left: 208px;\n}\n.delete[data-v-12a6c587]:hover {\n  color: red;\n  cursor:pointer\n}\n", ""]);

// exports
